module.exports = __webpack_public_path__ + "static/media/logoEricson.970d8cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logoEricson.png
// module id = 879
// module chunks = 0